(() => {
 'use strict';
 if(window.__bellziGiftExtrasMounted)return;
 const source=document.querySelector('#BellziGiftExtras');
 if(!source||document.body.dataset.preview==='true')return;
 window.__bellziGiftExtrasMounted=true;
 const root=window.Shopify?.routes?.root||'/';
 const labels=JSON.parse(document.querySelector('#BellziGiftLabels').textContent);
 let template=source,cart=null,busy=false,group='first',request=0;
 const openState=new Map();
 const notices=new Map();
 let pendingFocus=null;
 function captureFocus(){
  const active=document.activeElement;
  const panel=active?.closest('[data-gift-extras]');
  if(!panel)return null;
  const kind=panel.closest('.cart-drawer')?'drawer':'page';
  const row=active.closest('[data-gift-variant]');
  return {kind,variant:row?.dataset.giftVariant,occasion:active.dataset.giftOccasion,add:active.matches('[data-gift-add]'),summary:active.matches('summary')};
 }
 function restoreFocus(saved){
  if(!saved)return;
  const host=hosts().find(([kind])=>kind===saved.kind)?.[1];
  if(!host||(saved.kind==='drawer'&&!host.closest('dialog')?.open))return;
  const panel=host.querySelector('[data-gift-extras]');
  if(!panel)return;
  let target;
  if(saved.occasion)target=[...panel.querySelectorAll('[data-gift-occasion]')].find(b=>b.dataset.giftOccasion===saved.occasion&&!b.hidden);
  if(saved.variant){
   const row=[...panel.querySelectorAll('[data-gift-variant]')].find(r=>r.dataset.giftVariant===saved.variant&&!r.hidden);
   target=saved.add?row?.querySelector('[data-gift-add]:not(:disabled)'):row?.querySelector('h3 a');
   target||=row?.querySelector('h3 a');
  }
  (target||panel.querySelector('summary'))?.focus({preventScroll:true});
 }
 const json=async(url,options={})=>{
  const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,headers:{Accept:'application/json',...options.headers},signal:AbortSignal.timeout(12000)});
  const data=await response.json();
  if(!response.ok)throw Object.assign(new Error(typeof data.description==='string'?data.description:labels.error),{status:response.status});
  return data;
 };
 const freshTemplate=async()=>{
  const url=new URL(root,location.origin);url.searchParams.set('section_id',source.dataset.sectionId);url.searchParams.set('_gift_check',Date.now());
  const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});
  if(!response.ok)throw Error(labels.error);
  const doc=new DOMParser().parseFromString(await response.text(),'text/html');
  return doc.querySelector('#BellziGiftExtras');
 };
 const inBag=id=>cart?.items.some(item=>String(item.product_id)===String(id)&&item.quantity>0);
 const hosts=()=>[
  ['drawer',document.querySelector('.cart-drawer .drawer-content')],
  ['page',document.querySelector('.cart-page .cart-summary')]
 ].filter(([,host])=>host);
 function mount(){
  const saved=captureFocus()||pendingFocus;pendingFocus=null;
  for(const [kind,host] of hosts()){
   const old=host.querySelector('[data-gift-extras]');
   if(old)openState.set(kind,old.open);
   if(old)old.remove();
   const drawer=host.closest('.cart-drawer');
   if(drawer)drawer.dataset.largeBag=String((cart?.item_count||0)>=4);
   if(!cart?.items.length||!template)continue;
   const el=template.content.querySelector('[data-gift-extras]')?.cloneNode(true);
   if(!el)continue;
   const seen=new Set();
   el.querySelectorAll('[data-gift-product]').forEach(row=>{
    const id=row.dataset.giftProduct;
    if(row.dataset.requiresProduct&&(!inBag(row.dataset.requiresProduct)||inBag(id))){row.remove();return;}
    if(seen.has(id)){row.remove();return;}seen.add(id);
    const button=row.querySelector('[data-gift-add]');
    button.disabled=busy||inBag(id);button.textContent=inBag(id)?labels.added:labels.add;
    button.setAttribute('aria-label',inBag(id)?button.dataset.addedLabel:button.dataset.addLabel);
    button.addEventListener('click',()=>add(row,kind));
   });
   const rows=[...el.querySelectorAll('[data-gift-product]')];
   if(!rows.length)continue;
   const groups=[...new Set(rows.filter(row=>!row.dataset.requiresProduct).map(row=>row.dataset.giftGroup))];
   if(!groups.includes(group))group=groups[0];
   el.querySelectorAll('[data-gift-occasion]').forEach(button=>{
    button.hidden=!groups.includes(button.dataset.giftOccasion);
    button.addEventListener('click',()=>{group=button.dataset.giftOccasion;selectGroup(el);});
   });
   selectGroup(el);
   el.open=openState.has(kind)?openState.get(kind):(rows.some(row=>row.dataset.requiresProduct)||kind==='page'||cart.item_count<4);
   el.querySelector('summary').addEventListener('click',()=>openState.set(kind,!el.open));
   if(kind==='page')host.insertBefore(el,host.querySelector('.cart-total'));
   else host.append(el);
   const notice=notices.get(kind);if(notice)message(kind,notice.value,notice.link);
  }
  restoreFocus(saved);
 }
 function selectGroup(el){
  el.querySelectorAll('[data-gift-occasion]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.giftOccasion===group)));
  el.querySelectorAll('[data-gift-product]').forEach(row=>{row.hidden=!row.dataset.requiresProduct&&row.dataset.giftGroup!==group;});
 }
 function message(kind,value,link=false){
  notices.set(kind,{value,link});
  const host=hosts().find(([key])=>key===kind)?.[1];
  const box=host?.querySelector('.gift-extras-message');
  if(box){box.hidden=false;box.textContent=value;if(link){const a=document.createElement('a');a.href=root+'cart';a.textContent=' '+labels.view;box.append(a);}}
  else if(kind==='drawer'){
   const status=document.querySelector('.cart-drawer .drawer-error');if(status){status.textContent=value;status.hidden=false;}
  }else if(host){
   let status=host.querySelector('[data-gift-status]');
   if(!status){status=document.createElement('p');status.dataset.giftStatus='';status.setAttribute('role','status');host.prepend(status);}
   status.textContent=value;
  }
 }
 async function refresh(){
  const version=++request;
  try{const next=await freshTemplate();if(version!==request||busy)return;template=next;mount();}
  catch(_){if(version===request&&!busy){template=null;mount();}}
 }
 async function refreshPage(oldCart){
  const page=document.querySelector('.cart-page');if(!page)return;
  const dirty=new Map();
  page.querySelectorAll('[name="updates[]"]').forEach((input,index)=>{if(input.value!==input.defaultValue&&oldCart.items[index])dirty.set(oldCart.items[index].key,input.value);});
  const note=page.querySelector('[name="note"]');const noteValue=note?.value;
  const section=page.closest('[id^="shopify-section-"]');
  if(!section)throw Error(labels.refresh);
  const url=new URL(root+'cart',location.origin);url.searchParams.set('section_id',section.id.replace('shopify-section-',''));
  const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
  if(!response.ok)throw Error(labels.refresh);
  const fresh=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('.cart-page');
  if(!fresh)throw Error(labels.refresh);
  fresh.querySelectorAll('[name="updates[]"]').forEach((input,index)=>{const value=dirty.get(cart.items[index]?.key);if(value!==undefined)input.value=value;});
  const newNote=fresh.querySelector('[name="note"]');if(newNote&&noteValue!==undefined)newNote.value=noteValue;
  page.replaceWith(fresh);
 }
 async function add(row,kind){
  if(busy)return;
  busy=true;++request;
  const id=row.dataset.giftVariant,productId=row.dataset.giftProduct;
  const clicked=row.querySelector('[data-gift-add]');clicked.textContent=labels.adding;
  clicked.setAttribute('aria-label',clicked.dataset.addingLabel);
  document.querySelectorAll('[data-gift-add]').forEach(b=>b.disabled=true);
  let added=false,attempted=false,oldCart=cart,notice='',link=false;
  try{
   const [fresh,current]=await Promise.all([freshTemplate(),json(root+'cart.js')]);
   template=fresh;cart=current;oldCart=current;
   if(inBag(productId)){notice=labels.added;return;}
   const eligible=template?.content.querySelector(`[data-gift-variant="${id}"]`);
   if(!eligible||(eligible.dataset.requiresProduct&&!inBag(eligible.dataset.requiresProduct))){notice=labels.unavailable;return;}
   attempted=true;
   await json(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
   added=true;
   cart=await json(root+'cart.js');
   if(kind==='page')await refreshPage(oldCart);
   document.dispatchEvent(new CustomEvent('bellzi:cart-updated',{detail:{cart,open:false}}));
   notice=labels.success;
  }catch(error){
   if(error.status===422){notice=labels.unavailable;try{template=await freshTemplate();}catch(_){template=null;}}
   else if(attempted){
    try{cart=await json(root+'cart.js');added=inBag(productId);if(kind==='page')await refreshPage(oldCart);document.dispatchEvent(new CustomEvent('bellzi:cart-updated',{detail:{cart,open:false}}));notice=added?labels.success:labels.error;}
    catch(_){notice=labels.refresh;link=true;template=null;}
   }else{notice=labels.error;template=null;}
  }finally{
   busy=false;mount();message(kind,notice,link);
   const host=hosts().find(([key])=>key===kind)?.[1];
   if(kind!=='drawer'||host?.closest('dialog')?.open)(host?.querySelector(`[data-gift-variant="${id}"] h3 a`)||host?.querySelector('[data-gift-extras] summary'))?.focus({preventScroll:true});
  }
 }
 document.addEventListener('bellzi:cart-state',event=>{
  pendingFocus=captureFocus()||pendingFocus;
  if(!busy)notices.clear();
  cart=event.detail.cart;
  queueMicrotask(()=>{mount();if(!busy)refresh();});
 });
 document.addEventListener('visibilitychange',()=>{if(!document.hidden&&!busy)refresh();});
 if(document.querySelector('.cart-page'))json(root+'cart.js').then(current=>{cart=current;mount();refresh();}).catch(()=>{});
 document.addEventListener('shopify:section:load',()=>{if(!busy)refresh();});
})();

